import { ImgHTMLAttributes, ReactNode, useState } from "react";

import { MediaPlaceholder } from "./MediaPlaceholder";

interface FallbackImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    fallback?: ReactNode;
}

export const FallbackImage = ({
    src,
    alt = "",
    className,
    style,
    width,
    height,
    fallback,
    onError,
    ...imageProps
}: FallbackImageProps) => {
    const [failedSrc, setFailedSrc] = useState<string | null>(null);

    if (!src || failedSrc === src) {
        if (fallback !== undefined) return <>{fallback}</>;

        return (
            <MediaPlaceholder className={className} style={style} width={width} height={height} />
        );
    }

    return (
        <img
            {...imageProps}
            src={src}
            alt={alt}
            className={className}
            style={style}
            width={width}
            height={height}
            onError={(event) => {
                setFailedSrc(src);
                onError?.(event);
            }}
        />
    );
};
